import React from 'react';
import * as FiIcons from 'react-icons/fi';
import ProgressRing from '../status/ProgressRing';
import StatusDot from '../status/StatusDot';
import { agentIconRegistry } from '../../types/iconRegistry';

function AgentTile({ agent }) {
  const AgentIcon = agentIconRegistry[agent.icon] || FiIcons.FiCpu;

  return (
    <button className={`agent-tile agent-${agent.status}`} type="button">
      <div className="agent-heading">
        <div className="agent-avatar">
          <AgentIcon />
        </div>
        <ProgressRing value={agent.progress} />
      </div>
      <div className="agent-title">
        <div>
          <strong>{agent.name}</strong>
          <p>{agent.role}</p>
        </div>
        <StatusDot status={agent.status} pulse={agent.status === 'running'} />
      </div>
      <div className="agent-footer">
        <span>{agent.tasks} tasks today</span>
        <FiIcons.FiArrowUpRight />
      </div>
    </button>
  );
}

export default AgentTile;